import { render, staticRenderFns } from "./PackageTabRules.vue?vue&type=template&id=3536be28&scoped=true&"
import script from "./PackageTabRules.vue?vue&type=script&lang=js&"
export * from "./PackageTabRules.vue?vue&type=script&lang=js&"
import style0 from "./PackageTabRules.vue?vue&type=style&index=0&id=3536be28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3536be28",
  null
  
)

export default component.exports